<template>
  <div class="wrapper">
    <AdvertiserList :advertiserList="advertiserList" />
  </div>
</template>

<script>
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeLoginLp } from '@/mixins/setDrawerTypeLoginLp'
import { setToolBarTypeLoginLp } from '@/mixins/setToolBarTypeLoginLp'

import AdvertiserList from '@/components/LoginLp/Report/AdvertiserList'

import { actions as drawerActions } from '@/vuex/modules/ui/drawer/constants'

export default {
  name: 'Report',
  components: { AdvertiserList },
  mixins: [accountInitializer, setDrawerTypeLoginLp, setToolBarTypeLoginLp],
  props: {
    advertiserList: {
      type: Object,
      default: () => {},
    },
  },
  beforeCreate() {
    this.$store.dispatch(drawerActions.CHANGE_DRAWER_TOGGLE_BUTTON_VISIBILITY, {
      flag: true,
    })
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
}
</style>
